import { Injectable } from '@angular/core';
import { TmsCollector, TmsCollectorConfig, WindowObject } from '@spartacus/tracking/tms/core';
import { CxEvent } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class Ga4CollectorService implements TmsCollector {
  init(config: TmsCollectorConfig, windowObject: WindowObject): void {}

  pushEvent<T extends CxEvent>(config: TmsCollectorConfig, windowObject: WindowObject, event: any): void {
    const dataLayerProperty = config.dataLayerProperty ?? 'dataLayer';

    if (windowObject[dataLayerProperty]) {
      windowObject[dataLayerProperty].push(event);
    }
  }
}
